// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kZtS","tabsBox":"styles_tabsBox__3YNO1","createButton":"styles_createButton__RpOvH"};